/* eslint-disable no-undef */
/* eslint-disable */
import Vue from "vue";
import store from "./store";
import router from "./router";
import App from "./App.vue";
import axios from "axios";
import VueMq from "vue-mq";
import VModal from "vue-js-modal";
import VeeValidate,{ Validator } from "vee-validate";
import VueLazyload from "vue-lazyload";
import Inview from "vueinview";
import Meta from "vue-meta";
import Vue2Filters from "vue2-filters";
import moment from "moment";


// app version
const version_number = 1.2;


// vue config
Vue.config.preformance = true;
// Vue.config.performance = false;
// Vue.config.devtools = true ;

//Vue.config.globalProperties.$googleMapsApiKey = 'AIzaSyDgeMo1EDzJEVla2qgZ3h179Dt9L8KOdrI';


// vue uses
Vue.use(Inview);
Vue.use(Meta);
Vue.use(Vue2Filters);
Vue.use(VueLazyload, {
	observer: true,
	observerOptions: {
		rootMargin: "0px",
		threshold: 0.1,
	},
	error: wpData.assets_url + "/layout/empty.jpg",
	// loading: wpData.assets_url + "/layout/empty.jpg",
	attempt: 3,
});
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(VueMq, {
	breakpoints: {
		mobile: 800,
		desktop: Infinity,
	},
});
Vue.use(VeeValidate, {
	events: "blur",
});
const dict = {
	messages: {
		email: () => "הי, שכחת לכתוב את המייל.",
		phone: () => "מספר הטלפון לא תקין",
		emailconf: () => "כתובות המייל לא זהות",
	},
	custom: {
		reset_pass_phone: {
			required: "הי, שכחת לכתוב את הטלפון. ",
			regex: " הטלפון שהוקלד לא תקין",
		},
		email: {
			required: "הי, שכחת לכתוב את המייל. ",
			email: "המייל שהוקלד לא תקין",
		},
		emailconf: {
			required: "הי, שכחת לכתוב את המייל.",
			is: "כתובות המייל לא זהות",
		},
		password: {
			required: "שכחת למלא סיסמה",
			min: "יש לבחור סיסמה באורך 6 תווים לפחות",
		},
		username: {
			required: "הי, שכחת לכתוב את המייל.",
		},
		subscribe: {
			required: "יש לאשר שדה חובה.",
		},
		terms: {
			required: "לא אישרת את תנאי השימוש. בלי זה לא נוכל להאכיל אותך.",
		},
		billing_first_name: {
			required: "שם ושם משפחה בבקשה.",
			regex: "יש להזין שם פרטי בעברית",
		},
		billing_last_name: {
			required: "שם ושם משפחה בבקשה.",
			regex: "יש להזין שם משפחה בעברית",
		},
		firstname: {
			required: "איך קוראים לך ? חשוב לנו לדעת.",
			regex: "יש להזין שם פרטי בעברית",
		},
		lastname: {
			required: "אנחנו צריכים גם את שם המשפחה...",
			regex: "יש להזין שם משפחה בעברית",
		},
		billing_phone: {
			required: "מה מספר הטלפון?",
			regex: "מספר הטלפון שהקלדת לא תקין",
		},
		billing_phonesec: {
			required: "יש להזין מספר טלפון תקין",
			regex: "מספר הטלפון שהקלדת לא תקין",
		},
		billing_email: {
			required: "היי, שכחת לכתוב את המייל",
			exist: "כתובת דוא״ל קיימת במערכת",
		},
		billing_email_confirm: {
			required: "היי, שכחת לכתוב את המייל",
			confirmed: "כתובות המייל שהקלדת לא זהות",
		},
		billing_city: {
			required: "שכחת לבחור לאיזו עיר אנחנו צריכים להגיע.",
		},
		billing_address_street: {
			required: "השליח צריך לדעת לאן להגיע...",
			regex: "יש להזין רחוב בעברית.",
		},
		billing_address_house: {
			required: "השליח צריך לדעת לאן להגיע...",
		},
		billing_address_apart: {
			required: "איפה לשים? (אפשר 0)",
		},
		billing_address_floor: {
			required: "איפה לשים? (אפשר 0)",
		},
		account_password: {
			required: "שכחת למלא סיסמה.",
			min: "יש לבחור סיסמה באורך 6 תווים לפחות",
		},
		shipping_first_name: {
			required: "יש להזין שם פרטי.",
			regex: "יש להזין שם פרטי בעברית",
		},
		shipping_last_name: {
			required: "יש להזין שם משפחה.",
			regex: "יש להזין שם משפחה בעברית",
		},
		shipping_phone: {
			required: "מה המספר טלפון?",
			regex: "מספר הטלפון שהקלדת לא תקין.",
		},
		shipping_phonesec: {
			regex: "מספר הטלפון שהקלדת לא תקין.",
		},
		shipping_email: {
			required: "היי, שכחת לכתוב את המייל",
		},
		shipping_city: {
			required: "שכחת לבחור לאיזו עיר אנחנו צריכים להגיע.",
		},
		shipping_address_street: {
			required: "השליח צריך לדעת לאן להגיע...",
			regex: "יש להזין רחוב בעברית.",
		},
		shipping_address_house: {
			required: "השליח צריך לדעת לאן להגיע...",
		},
		shipping_address_apart: {
			required: "איפה לשים? (אפשר 0)",
		},
		shipping_address_floor: {
			required: "איפה לשים? (אפשר 0)",
		},
		subtitue_products: {
			required: "אנחנו חייבים לדעת אם כן או לא?",
		},
		city: {
			required: "היי, שכחת לכתוב את שם היישוב",
			min: "היי, שכחת לכתוב את שם היישוב",
		},
		ship_time: {
			required: "יש לבחור זמן משלוח",
		},
		order_alternateproducts: {
			required: "אנחנו חייבים לדעת אם כן או לא :)",
		},
		phone_login: {
			required: "מה מספר הטלפון?",
			regex: "מספר הטלפון שהקלדת לא תקין",
		},
		sms_otp: {
			required: "יש להזין את קוד האימות שקיבלת לטלפון הנייד שלך",
			min: "יש להזין קוד בן 6 ספרות",
			max: "יש להזין קוד בן 6 ספרות",
		},
		business_name: {
			required: "חובה להזין שם עסק",
		},
		business_tax_id: {
			required: "חובה להזין ח.פ או ת.ז",
		},
		birthday_day: {
			regex: "יש להזין יום, בין 01-31",
		},
		birthday_month: {
			regex: "יש להזין חודש, בין 01-12",
		},
		birthday_year: {
			regex: "יש להזין שנה",
		},
	},
};
Validator.localize("en", dict);


// components
Vue.component("a-div", require("fh-components/a-div"));


// prototypes
Vue.prototype.$ajax = axios.create({
	baseURL: ajaxUrl,
	headers: {
		"X-Requested-With": "XMLHttpRequest",
		"Content-Type": "text/html",
		charset: "utf-8",
	}
});
Vue.prototype.$ajaxController = new AbortController();
Vue.prototype.$wpData = wpData;


// vue mixins
Vue.mixin({
	methods: {
		sendImmpressionsProducts(products) {
			if (typeof products !== "undefined" && products) {
				var list = [];
				//console.log(this.$refs.mainVue);
				//console.log(this.$refs.mainVue.$refs);

				var category = "";
				var list_name = this.$route.name;
				if (this.$route.name == "subcategory") {
					category = this.$route.params.subcat;
					list_name = this.$route.name;
				}
				if (this.$route.name == "category") {
					category = this.$route.params.cat;
					list_name = this.$route.name;
				}
				products.map(function (value, key) {
					let productObj = {};
					let position = key + 1;
					productObj.id = value.product.id;
					productObj.name = value.product.name;
					productObj.price = value.product.price;
					productObj.category = category;
					productObj.list = list_name;
					productObj.position = position;
					list.push(productObj);
				});

				var maxProducts = 5;
				while (list.length) {
					var p1 = list.splice(0, maxProducts);
					if (typeof dataLayer !== "undefined") {
						dataLayer.push({
							event: "impression",
							ecommerce: {
								currencyCode: "ILS",
								impressions: p1,
							},
						});
					}
				}
			}
		},
	},
});

// setup vue app
new Vue({
	el: "#carmella-vue",
	router,
	store,
	metaInfo() {
		return {
			title: this.pageData.yoast_title ? this.pageData.yoast_title : this.pageData.title,
			titleTemplate: "%s",
		};
	},
	data: {
		wpData: wpData,
		pageTitle: "",
	},
	computed: {
		page: function () {
			//return wpData.pageData ? JSON.parse(wpData.pageData) : "";
			if (typeof wpData.pageData == "string" && wpData.pageData !== "") {
				return JSON.parse(wpData.pageData);
			}
			if (typeof wpData.pageData == "object") {
				return wpData.pageData;
			}
			return "";
		},
		pageData: function () {
			if (typeof wpData.pageData == "string" && wpData.pageData !== "") {
				return JSON.parse(wpData.pageData);
			}
			if (typeof wpData.pageData == "object") {
				return wpData.pageData;
			}
			return "";
		},
	},
	beforeCreate() {
		store.dispatch("getCategories");
		if (this.$route.name == "category" || this.$route.name == "subcategory") {
			store.dispatch("setAjaxProducts");
		}
		store.dispatch("getSales");
		if (wpData.user) {
			store.commit("setUserInfo", wpData.user);
		} else {
			store.commit("clearUser");
		}

		store.dispatch("getBogoSales");
	},
	mounted() {
		// always get cart from server
		//if (store.state.added.length === 0) {
		if (wpData.user.cart && wpData.user.cart.length > 0) {
			wpData.user.cart.forEach(product => {
				store.commit('updateCart', {product: product, is_edit: false, onPageLoad: true});
			});
			store.state.showCartRecoveredNotice = true;
		}

		// if url has "?auth-as-user=1" pull cart from server
		let urlParameters = new URLSearchParams(window.location.search);
		let hasImpersonatedCookie = document.cookie.includes('impersonated_by');

		if (urlParameters.get("auth-as-user") == 1 || hasImpersonatedCookie) {
			let now = new Date().toJSON();
			this.$store.commit("clearCart");
			this.$store.state.added = [];
			let localStorageItemsToRemove = [
				"flashy_sessions_count",
				"full_cart",
				"google_cart",
				"shopping_cart",
				"last_sent_cart_time",
			];
			localStorageItemsToRemove.forEach((item) => localStorage.removeItem(item));
			localStorage.setItem("last_update_time", now);
			this.$store.dispatch("updateCartFromServer").then(() => {
				this.$store.dispatch("sendCartToServer");
			}).catch((e) => {
				console.log(e);
			});
		}

		// if version update, pull cart from server -- currently not used
		this.checkVersion();

		this.$nextTick(() => {
			store.dispatch("initToolTip");
			$(".ui-tooltil").hide();
		});

		// check order edit still possible
		let order_edit_time = localStorage.getItem("carmella-orderedit_time");
		if (typeof order_edit_time != "undefined") {
			let date_now = moment();
			let order_edit_date = moment(order_edit_time);
			let days_diff = date_now.diff(order_edit_date, "days");
			if (days_diff >= 3) {
				this.$store.commit("setOrderEdit", false);
				this.$store.commit("clearCart");
				//window.location.reload();
			}
		}

		// hourly check - cancel order edit if more than 3 days passed from edit start date
		setInterval(() => {
			let order_edit_time = localStorage.getItem("carmella-orderedit_time");
			let date_now = moment();

			if (typeof order_edit_time != "undefined") {
				let order_edit_date = moment(order_edit_time);
				let days_diff = date_now.diff(order_edit_date, "days");
				if (days_diff >= 3) {
					this.$store.commit("setOrderEdit", false);
					this.$store.commit("clearCart");
					//window.location.reload();
				}
			}
		}, 1000 * 60 * 60);

		// hourly check - update products prices, check if order is still editable
		setInterval(() => {
			store.dispatch("updateProducts");
			if (store.state.userLogged) {
				store.dispatch("checkOrderEdit", true);
			}
		}, 1000 * 60 * 60);

		// daily check - user still logged in
		setInterval(() => {
			this.$ajax
				.get(ajaxUrl + "?action=isUserLogged")
				.then((resposne) => {
					if (resposne.data.success) {
						var user = resposne.data.data;
						store.commit("setUserInfo", user);
						store.dispatch("updateCartFromServer");
					} else {
						store.commit("clearUser");
					}
				})
				.catch((e) => {
					console.log(e);
				});
		}, 1000 * 60 * 60 * 24);

		// send cart to server every 2 minutes

		// if (store.state.userLogged) {
		// 	store.dispatch("checkOrderEdit");
		// 	setInterval(() => {
		// 		var last_update_time =
		// 			localStorage.getItem("last_update_time") &&
		// 			typeof localStorage.getItem("last_update_time") != "undefined"
		// 				? localStorage.getItem("last_update_time")
		// 				: false;
		// 		var last_sent_cart_time =
		// 			localStorage.getItem("last_sent_cart_time") &&
		// 			typeof localStorage.getItem("last_sent_cart_time") != "undefined"
		// 				? localStorage.getItem("last_sent_cart_time")
		// 				: false;
		// 		if (!last_sent_cart_time && last_update_time) {
		// 			console.log('2');
		// 			store.dispatch("sendCartToServer");
		// 		} else {
		// 			let date1 = new Date(last_update_time);
		// 			let date2 = new Date(last_sent_cart_time);
		// 			let diff = date1 - date2;
		// 			if (diff > 0) {
		// 				console.log('3');
		// 				store.dispatch("sendCartToServer");
		// 			}
		// 		}
		// 	}, 1000 * 60 * 2);
		// }

		$(document.body).on("click", function (e) {
			$("body").removeClass("noscroll");

			if ($(e.target).hasClass("popup_in")) {
				let _this = Vue.prototype;
				_this.$modal.hide("prod-modal");
				_this.$modal.hide("login-modal");
				_this.$modal.hide("product-note");
				_this.$modal.hide("password-modal");
				_this.$modal.hide("not-exist");
				_this.$modal.hide("delivery");
				_this.$modal.hide("cvform");
				_this.$modal.hide("sales-pop");
				_this.$modal.hide("hours-modal");
				$(".ui-tooltil").hide();
			}
			if ($(e.target).hasClass("cart")) {
				$("body").removeClass("noscroll");
				$(".cart_in").animate(
					{
						left: "-100%",
					},
					600,
					function () {
						$(".cart").fadeOut();
					}
				);
			}
		});

		// Handle blog scroll to
		$(document.body).on("click", ".skip-to-recipe .button", function () {
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: $(".sec_recipe .recipe_img").offset().top - 60,
				},
				1300
			);
		});

		if (wpData.coupons.length) {
			console.log('wpData.coupons', wpData.coupons);
			wpData.coupons.forEach(coupon => {
				// currently supports only 1 coupon in state
				store.commit("setCoupon", coupon);
			});
		}

		// setup inApp variable
		store.dispatch('setInApp');

		if (urlParameters.get("flashy_cart") === 'true' ) {
			store.dispatch("updateCartFromServer");
		}


		// update member points
		if (wpData.user) {
			store.dispatch('syncCashbackPointsComax')
		}
	},
	watch: {
		$route(to, from) {
			if (to.path != from.path) {
				this.$nextTick(() => {
					store.dispatch("initToolTip");
					$(".ui-tooltil").hide();

					if (typeof sendFlashyEvent != "undefined") {
						if (store.state.userLogged) {
							let user = store.state.userLoggedInfo;
							sendFlashyEvent(user);
						}
					}
				});
			}
		},
		"$store.state.userLogged"(value) {
			if (value) {
				store.state.storedFavs = [...store.state.userLoggedInfo.favoriteProducts];

				setInterval(() => {
					var last_update_time =
						localStorage.getItem("last_update_time") &&
						typeof localStorage.getItem("last_update_time") != "undefined"
							? localStorage.getItem("last_update_time")
							: false;
					var last_sent_cart_time =
						localStorage.getItem("last_sent_cart_time") &&
						typeof localStorage.getItem("last_sent_cart_time") != "undefined"
							? localStorage.getItem("last_sent_cart_time")
							: false;
					if (!last_sent_cart_time && last_update_time) {
						if (this.$route.name != "checkout") {
							console.log('4');
							store.dispatch("sendCartToServer");
						}
					} else {
						let date1 = new Date(last_update_time);
						let date2 = new Date(last_sent_cart_time);
						let diff = date1 - date2;
						if (diff > 0) {
							if (this.$route.name != "checkout") {
								console.log('5');
								store.dispatch("sendCartToServer");
							}
						}
					}
				}, 1000 * 60 * 2);

				// ONLY IF CART IS EMPTY - load it from server, else
				if (store.state.added.length === 0) {
					//store.dispatch("updateCartFromServer");
				}

				// update cashback points from comax
				store.dispatch('syncCashbackPointsComax');

			} else {
				let order_edit = localStorage.getItem("carmella-orderedit");
				if (typeof order_edit !== "undefined" && order_edit) {
					this.$store.commit("clearCart");
					store.dispatch("clearCartFromServer");
				}
			}
		},
	},
	methods: {
		checkVersion() {
			var current_version = localStorage.getItem("carmella-version");
			if (!current_version || parseFloat(current_version) != version_number) {
				localStorage.setItem("carmella-version", version_number);
				/** Version UPDATED do somthing */
				//store.dispatch("updateCartFromServer");
			}
		}
	},
	render: (h) => h(App),
});
